import LabelProvider from "core/components/label/LabelProvider";


export default LabelProvider.create({

    Institution: {
		k: "catalog.institution",
		v: "Institution(s)"
	}	

});



// WEBPACK FOOTER //
// ./src/panels/institutions/InstitutionsFilter.labels.tsx